import request from './request'

// 统一角色主表（role）管理接口

export function getRoleList(params) {
  return request({
    url: '/admin/system/role',
    method: 'get',
    params
  })
}

export function getRole(id) {
  return request({
    url: `/admin/system/role/${id}`,
    method: 'get'
  })
}

export function createRole(data) {
  return request({
    url: '/admin/system/role',
    method: 'post',
    data
  })
}

export function updateRole(id, data) {
  return request({
    url: `/admin/system/role/${id}`,
    method: 'put',
    data
  })
}

export function deleteRole(id) {
  return request({
    url: `/admin/system/role/${id}`,
    method: 'delete'
  })
}
